export enum TopicCustomerType{
    IVA = "IVA", 
    RESIDENZIALE = "RESIDENZIALE"
}


export enum TopicFastwebCustomerType{
    FASTWEB = "FASTWEB", 
    GENERIC = "GENERIC"
}


//Create, update
export class TopicRequest{
    customerType: any;
    fastwebCustomerType: any;
    title: string;
    // value: string;
}


export class TopicRequestSearch{
    customerType: any;
    fastwebCustomerType: any;
    title:  string;
    value:  string;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    
}
